// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SCSS Document */
/*\$main-gray-text-color: #333;*/
/*IN MAIN STATIC*/
body {
  /*main background color*/
  /*background-color:#2b71b1;*/
  background-color: #FFF;
}

/*----------Full Width Bootstrap-----------------------*/
.container-fluid-full {
  margin: 0 auto;
  width: 100%;
}

/*----------Navigation Bars----------------------------*/
.navbar {
  margin: 0;
  border-radius: 0;
}

/* Override navbar defaults */
.navbar.navbar-default {
  border: 0;
}

.navbar.navbar-default .navbar-collapse {
  border: 0;
}

.navbar > .container {
  width: 95%;
  padding: 0;
  margin-left: 2%;
  margin-right: 0;
}

.nav-Custom-white {
  background: white !important;
}

.nav-Custom-clear {
  background: rgba(180, 190, 180, 0.1) !important;
}

.nav-Custom-blue {
  background: #2b71b1 !important;
}

.nav-Custom-lightBlue {
  background: #82a8f2 !important;
}

.nav-Custom-grey {
  background: #5d5f63 !important;
}

/*----------Full With Sections----------------------------*/
/*
.section1_fullWidthImage {
    background-image:url(../img/blueWindow.jpg);
    background-position:centertop;
    background-repeat:no-repeat;
    background-size:cover;
    margin:0 auto;
    padding:20px 0px 300px 0px;
}
*/
.section1_fullWidthColor {
  background-color: #383b3f;
  /*background-color: #1DD1C4; */
  /*background-color: #22D4C7;*/
  /*background: #2E5785;*/ /*DARK BLUE*/
  /*Using a background image on top of a background colour in CSS*/
  background-size: cover;
  width: 100%;
  margin: 0 auto;
  min-height: 600px;
}

/*
.section1_login {
    background-color: #FFF;
    #background-color: #E6E6E6;
    width:100%;
    margin:0 auto;
    min-height: 220px; }
*/
.avatar {
  display: block;
  box-sizing: border-box;
  border: 5px solid #8B8C8F;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.introBox {
  /*on jumbatron on main page*/
  margin-top: 150px;
  background-color: rgba(255, 255, 255, 0);
  color: #FFF;
  padding: 20px;
}

.signUp {
  margin-top: 150px;
  margin-bottom: 100px;
  background-color: #2E5785;
  color: #5C5C5C;
  padding-top: 0px;
  padding-bottom: 20px;
}

.srsignUp {
  margin-top: 130px;
  margin-bottom: 100px;
  background-color: white;
  color: #5C5C5C;
  padding-top: 0px;
  padding-bottom: 20px;
  border-radius: 20px;
}

.preLoginBox {
  margin-top: 80px;
  margin-bottom: 100px;
  background-color: white;
  color: #5C5C5C;
  padding-top: 0px;
  padding-bottom: 20px;
  border-radius: 20px;
}

.sectionJobPostingCompanySummary, .sectionJobPostingJD, .sectionEditAndCreateJob {
  background-color: #FFF;
  width: 100%;
  min-height: 220px;
  margin: 0 auto;
  padding-bottom: 40px;
  color: #404040;
}

.sectionJobPostingCompanySummary {
  padding-top: 0px;
  border-bottom: solid 2px #D1D1D1;
}

.sectionEditAndCreateJob {
  padding-top: 0px;
}

.sectionJobPostingJD {
  padding-top: 40px;
}

.sectionJobPostingGrey {
  background-color: #E6E6E6;
  width: 100%;
  min-height: 220px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
  color: #5C5C5C;
}

/*------------Custom Margins--------------------------*/
.noLeftMargin {
  margin-left: 0px !important;
}

.noRightMargin {
  margin-right: 0px !important;
}

.colPaddingLeft12 {
  padding-left: 12px !important;
}

.marginLeftNeg15 {
  margin-left: -15px;
}

.marginLeft15 {
  margin-left: 15px;
}

.paddingTop5 {
  padding-top: 5px;
}

.paddingLeft30 {
  padding-left: 30px;
}

.buttomMargin15 {
  margin-left: 15px;
}

.mainColumnParent {
  margin-top: 20px;
  padding: 0px;
  background-color: #FFF;
}

.resumeformatSkillsBox:hover,
.resumeformatLHBox:hover,
.resumeformatRHBox:hover,
.resumeformatReferencesBox:hover,
.resumeformatLanguageBox:hover,
.resumeformatMainBox:hover,
.resumeformatEducationBox:hover {
  cursor: pointer;
}

.menuBox {
  background-color: #FFF;
}

.settingBox {
  padding-top: 5px;
  padding-bottom: 15px;
}

.resumeRepositoryElement {
  padding-top: 5px;
}

.profileContentBox {
  padding-top: 15px;
  padding-bottom: 15px;
}

.alignCenter {
  text-align: center;
}

/*---ResumeFormat---*/
.customResFormatMainColumnParentPadding {
  padding-left: 20px;
}

.resumeformatBox, .resumeEditPopupBox, .resumeformatBoxSmall, .resumeformatLHBox, .resumeformatRHBox, .resumeformatMainBox, .resumeformatSkillsBox, .resumeformatLanguageBox, .resumeformatEducationBox, .resumeformatReferencesBox {
  /*a "virtual" class*/
  margin-bottom: 12px;
  overflow: hidden;
}

.resumeformatBoxSmall, .resumeformatLHBox, .resumeformatRHBox {
  /*a "virtual" class*/
  width: 49.1%;
  height: 140px;
}

.resumeformatLHBox {
  margin-right: 6px;
}

.resumeformatRHBox {
  margin-left: 6px;
}

.resumeformatMainBox {
  width: 99.6%;
  height: 380px;
}

.resumeformatSkillsBox {
  margin-left: 12px;
  height: 684px;
}

/*On Same Row*/
.resumeformatReferencesBox {
  margin-right: 6px;
  height: 140px;
}

.resumeformatEducationBox {
  margin-left: 6px;
  margin-right: 6px;
  height: 140px;
  /*set this and min-height box height as variable*/
}

.resumeformatLanguageBox {
  margin-left: 6px;
  height: 140px;
  /*set this and min-height box height as variable*/
}

/*End On Same Row*/
/*End Main Box Format*/
.resumeformatBoxElement {
  padding-top: 5px;
}

.resumeformatContentArea {
  font-size: 12px;
  margin-bottom: 20px;
}

/*end ResumeFormat*/
.lightBlueHeader {
  background-color: #B3B3FF;
  color: #002855;
  padding-top: 5px;
  padding-bottom: 5px;
}

.lightGrayHeader, .settingLightGrayHeader, .thickLightGrayHeader {
  background-color: #E7E7E7;
  color: #7C7C7C;
}

.thickLightGrayHeader {
  padding-top: 10px;
  padding-bottom: 10px;
}

.whiteHeader {
  background-color: #fff;
  color: #4078c0;
}

.settingLightGrayHeader {
  padding-top: 5px;
}

/*--------Misc Styles---------------------------*/
p {
  padding: 0;
  margin: 0;
  display: inline;
}

.row-fluid {
  display: flex;
}

.vertical-align {
  display: flex;
  align-items: center;
}

.horizontal-align {
  display: flex;
  justify-content: space-around;
}

.vhr {
  border-left: 1px solid #eee;
  height: 100%;
}

.hrstyle {
  margin-top: 5px;
  margin-bottom: 5px;
}

.hrZeroMargin {
  margin-top: 0px;
  margin-bottom: 0px;
}

/*--------Boxes Style---------------------------*/
.grayBoxBorder, .resumeformatBox, .resumeformatBoxSmall, .resumeformatLHBox, .resumeformatRHBox, .resumeformatMainBox, .resumeformatSkillsBox, .resumeformatLanguageBox, .resumeformatEducationBox, .resumeformatReferencesBox, .jobOpeningListBox {
  border-color: #D6D0D0;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: 1px 1px 1px #D6D6D6;
  color: #4d4d4d;
}

.resumeEditPopupBox {
  border-color: #D6D0D0;
  border-style: solid;
  border-width: 1px;
  color: #4d4d4d;
}

.lightBoxBorder {
  border-color: #DEDCDC;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.lightBoxBorderNoRadius {
  border-color: #DEDCDC;
  border-style: solid;
  border-width: 1px;
}

.grayBoxElementUnderline {
  border-color: #D8D8D8;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.profileGreyBox {
  margin-bottom: 10px;
  background-color: #efefef;
  height: 80px;
}

.jobOpeningListBox:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}

.mainPageButtons {
  margin-top: 10px;
  margin-left: -15px;
}

/*Left Hand Menu*/
.menuItem > a {
  display: inline;
  color: #5C5C5C;
}

.menuItem {
  border-color: #C4C4C4;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.profileTitle {
  font-size: 120%;
}

.uploadicon {
  padding-top: 15px;
}

.section1_login .signUp {
  /*this reference of names ovverides original SignUp margins because login page has different top margins*/
  margin-top: 100px !important;
  margin-bottom: 50px !important;
}

.section2 {
  /*look at bootstrap tutorial*/
  background-color: #FFF;
  /*background-color: #DAE9F0;*/
  width: 100%;
  min-height: 220px;
  margin: 0 auto;
  padding-top: 15px;
  padding-bottom: 40px;
  /*color:#7E7E7E;*/
  color: #404040;
}

.section2_noMarginTop {
  background-color: #FFF;
  width: 100%;
  min-height: 220px;
  margin: 0 auto;
  padding-bottom: 40px;
  color: #404040;
}

.section2_enterprise {
  background-color: #EEE;
  width: 100%;
  min-height: 220px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
  color: #404040;
}

/*
.section3 {
    background-image: url(../img/startup9.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 600px;
    margin:0 auto;
    padding-top: 40px;
    padding-bottom: 40px;
    color: #7E7E7E; }
*/
.section4 {
  background-color: #E6E6E6;
  width: 100%;
  min-height: 220px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
  color: #5C5C5C;
}

/*    
.section4_fullWidthImage {
    background-image:url(../img/officeOrange.jpg);
    background-position:centertop;
    background-repeat:no-repeat;
    background-size:cover;
    margin:0 auto;
    min-height: 220px;
    color: #FFF;
    padding-top: 40px;
    padding-bottom: 40px;
}
*/
.section5 {
  background-color: #28B8ED;
  width: 100%;
  min-height: 220px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
  color: #FFF;
}

.section6 {
  background-color: #1DD1C4;
  /*background-color: #25d6c9;*/
  width: 100%;
  min-height: 220px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
  color: #FFF;
}

.section7 {
  background-color: #f69c3d;
  width: 100%;
  min-height: 220px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
  color: #FFF;
}

.section8 {
  background-color: #3E3F40;
  width: 100%;
  min-height: 220px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
  color: #FFF;
}

.sectionFooter {
  background-color: #FFF;
  width: 100%;
  margin: 0 auto;
  padding-top: 0px;
  padding-bottom: 100px;
  color: #8C8C8C;
}

.section2_row2 {
  margin-top: 40px;
}

.table tbody tr:hover td, .table-hover tbody tr:hover th {
  background-color: #F2F2F2;
}

.col-sm-half, .col-sm-1half, .col-sm-1half-no-padding, .col-sm-2half, .col-sm-2half-no-padding, .col-sm-2ThreeQuarter, .col-sm-3half, .col-sm-5half, .col-sm-5ThreeQuarter, .col-sm-7half, .col-sm-8half {
  position: relative;
  min-height: 1px;
  /*padding removed for default to not mess with LH and RH outer columns using these styles*/
  /*padding-right: 15px;
  padding-left: 15px;*/
}

@media (min-width: 768px) {
  .col-sm-half, .col-sm-1half, .col-sm-1half-no-padding, .col-sm-2half, .col-sm-2half-no-padding, .col-sm-2ThreeQuarter, .col-sm-3half, .col-sm-5half, .col-sm-5ThreeQuarter, .col-sm-7half, .col-sm-8half, .col-sm-offset-OneQuarter, .col-sm-offset-Half, .col-sm-offset-ThreeQuarter {
    float: left;
  }
  .col-sm-half {
    width: 4.166666667%;
  }
  .col-sm-1half {
    width: 12.49999999%;
    padding-right: 15px;
    padding-left: 15px;
  }
  .col-sm-1half-no-padding {
    width: 12.49999999%;
  }
  .col-sm-2half {
    width: 21.7%;
    padding-right: 15px;
    padding-left: 15px;
  }
  .col-sm-2half-no-padding {
    width: 21.7%;
  }
  .col-sm-2ThreeQuarter {
    width: 22.91666667%;
  }
  .col-sm-3half {
    width: 29.16666667%;
  }
  .col-sm-5half {
    width: 45.8333333%;
  }
  .col-sm-5ThreeQuarter {
    width: 47.91666667%;
  }
  .col-sm-7half {
    width: 62.5%;
  }
  .col-sm-8half {
    width: 70.83333333%;
  }
  .col-sm-offset-OneQuarter {
    margin-left: 2.08333333%;
  }
  .col-sm-offset-Half {
    margin-left: 4.16666667%;
  }
  .col-sm-offset-ThreeQuarter {
    margin-left: 6.25%;
  }
}
/* Flexbox */
.flex-container-row {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
}

.flex-space-around {
  justify-content: space-around;
}

.flex-space-between {
  justify-content: space-between;
}

.flex-align-center {
  align-items: center;
}

.modal-space-between-confirm-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

/* Whitespace */
.keep-whitespace {
  white-space: pre-line;
}

.rotate-fortyfive {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg); /* Safari/Chrome */
  -moz-transform: rotate(-45deg); /* Firefox */
  -o-transform: rotate(-45deg); /* Opera */
  -ms-transform: rotate(-45deg); /* IE 9 */
}

.hoverable:hover {
  background-color: #e6ecf5;
}

.modal-90w {
  width: 90% !important;
}

/* Sidebar stuff */
.sidebar {
  margin: 0;
}

.sidebar ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.sidebar ul li {
  margin: 0;
  padding: 15px 20px;
  font-size: 16px;
  font-weight: 100;
  color: white;
  display: block;
  -webkit-transition: background 0.3s ease-in-out;
  -moz-transition: background 0.3s ease-in-out;
  -ms-transition: background 0.3s ease-in-out;
  -o-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
}

.sidebar ul li:hover {
  background: #7c889c;
}

.imgStyle {
  width: 100%;
  height: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.imgStyle:hover {
  background-color: #000;
  opacity: 0.5;
  cursor: pointer;
}

.companyImgStyle {
  max-width: 200px;
  max-height: 200px;
}

/* Card */
.cardStyle {
  border: 1px solid #b9bcc7;
  border-radius: 8px;
  padding: 10px 10px 10px 10px;
}

.logoStyle {
  width: 10%;
}

.logoStyle:hover {
  cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./frontend/scss/style.scss"],"names":[],"mappings":"AAAA,kBAAA;AACA,+BAAA;AACA,iBAAA;AACA;EACE,wBAAA;EACA,4BAAA;EACA,sBAAA;AACF;;AAEA,wDAAA;AAEA;EACE,cAAA;EACA,WAAA;AAAF;;AAGA,wDAAA;AAEA;EACI,SAAA;EACA,gBAAA;AADJ;;AAIA,6BAAA;AACA;EACI,SAAA;AADJ;;AAIA;EACI,SAAA;AADJ;;AAIA;EACI,UAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AADJ;;AAIA;EACI,4BAAA;AADJ;;AAIA;EACI,+CAAA;AADJ;;AAIA;EACI,8BAAA;AADJ;;AAIA;EACI,8BAAA;AADJ;;AAIA;EACI,8BAAA;AADJ;;AAIA,2DAAA;AACA;;;;;;;;;CAAA;AAUA;EACI,yBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA,EAAA,YAAA;EACA,gEAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AADJ;;AAGA;;;;;;;CAAA;AASA;EACI,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,4EAAA;AADJ;;AAIA;EACI,4BAAA;EACA,iBAAA;EACA,wCAAA;EACA,WAAA;EACA,aAAA;AADJ;;AAGA;EACI,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;AAAJ;;AAEA;EACI,iBAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,cAAA;AACJ;;AACA;EACM,gBAAA;EACA,gCAAA;AAEN;;AACA;EACM,gBAAA;AAEN;;AACA;EACM,iBAAA;AAEN;;AACA;EACI,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;AAEJ;;AAAA,uDAAA;AAEA;EACI,2BAAA;AAEJ;;AAAA;EACI,4BAAA;AAGJ;;AADA;EACI,6BAAA;AAIJ;;AAFA;EACI,kBAAA;AAKJ;;AAHA;EACI,iBAAA;AAMJ;;AAJA;EACI,gBAAA;AAOJ;;AALA;EACI,kBAAA;AAQJ;;AANA;EACI,iBAAA;AASJ;;AAPA;EACI,gBAAA;EACA,YAAA;EACA,sBAAA;AAUJ;;AARA;;;;;;;EAOI,eAAA;AAWJ;;AARA;EACI,sBAAA;AAWJ;;AATA;EACI,gBAAA;EACA,oBAAA;AAYJ;;AAVA;EACI,gBAAA;AAaJ;;AAXA;EACI,iBAAA;EACA,oBAAA;AAcJ;;AAXA;EACI,kBAAA;AAcJ;;AAXA,qBAAA;AACA;EACI,kBAAA;AAcJ;;AAZA;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;AAeJ;;AAXA;EACI,oBAAA;EACA,YAAA;EACA,aAAA;AAcJ;;AAZA;EACI,iBAAA;AAeJ;;AAbA;EACI,gBAAA;AAgBJ;;AAdA;EACI,YAAA;EACA,aAAA;AAiBJ;;AAfA;EACI,iBAAA;EACA,aAAA;AAkBJ;;AAhBA,cAAA;AACA;EACI,iBAAA;EACA,aAAA;AAmBJ;;AAhBA;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,iDAAA;AAmBJ;;AAjBA;EACI,gBAAA;EACA,aAAA;EACA,iDAAA;AAoBJ;;AAnBA,kBAAA;AAEA,sBAAA;AAEA;EACI,gBAAA;AAoBJ;;AAlBA;EACI,eAAA;EACA,mBAAA;AAqBJ;;AAnBA,mBAAA;AAEA;EACI,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAqBJ;;AAnBA;EACI,yBAAA;EACA,cAAA;AAsBJ;;AApBA;EACI,iBAAA;EACA,oBAAA;AAuBJ;;AArBA;EACI,sBAAA;EACA,cAAA;AAwBJ;;AAtBA;EACI,gBAAA;AAyBJ;;AAvBA,iDAAA;AAEA;EACI,UAAA;EACA,SAAA;EACA,eAAA;AAyBJ;;AAtBA;EACI,aAAA;AAyBJ;;AAtBA;EACI,aAAA;EACA,mBAAA;AAyBJ;;AAtBA;EACI,aAAA;EACA,6BAAA;AAyBJ;;AAtBA;EACE,2BAAA;EACA,YAAA;AAyBF;;AAtBA;EACI,eAAA;EACA,kBAAA;AAyBJ;;AAtBA;EACI,eAAA;EACA,kBAAA;AAyBJ;;AAtBA,iDAAA;AAEA;EACI,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;EACA,cAAA;AAwBJ;;AAtBA;EACI,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AAyBJ;;AAvBA;EACI,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AA0BJ;;AAxBA;EACI,qBAAA;EACA,mBAAA;EACA,iBAAA;AA2BJ;;AAzBA;EACI,qBAAA;EACA,0BAAA;EACA,wBAAA;AA4BJ;;AA1BA;EACI,mBAAA;EACA,yBAAA;EACA,YAAA;AA6BJ;;AA1BA;EACE,0CAAA;AA6BF;;AA1BA;EACI,gBAAA;EACA,kBAAA;AA6BJ;;AA3BA,iBAAA;AACA;EACI,eAAA;EACA,cAAA;AA8BJ;;AA5BA;EACI,qBAAA;EACA,0BAAA;EACA,wBAAA;EACA,iBAAA;EACA,oBAAA;AA+BJ;;AA7BA;EACI,eAAA;AAgCJ;;AA9BA;EACI,iBAAA;AAiCJ;;AA/BA;EACI,yGAAA;EACA,4BAAA;EACA,8BAAA;AAkCJ;;AAhCA;EACI,6BAAA;EACA,sBAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;AAmCJ;;AAjCA;EACI,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,cAAA;AAoCJ;;AAlCA;EACI,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;AAqCJ;;AApCA;;;;;;;;;;CAAA;AAWA;EACI,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;AAuCJ;;AAtCA;;;;;;;;;;;;CAAA;AAaA;EACI,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AAyCJ;;AAvCA;EACI,yBAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AA0CJ;;AAxCA;EACI,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AA2CJ;;AAzCA;EACI,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AA4CJ;;AA1CA;EACI,sBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AA6CJ;;AA3CA;EACI,gBAAA;AA8CJ;;AA5CA;EACE,yBAAA;AA+CF;;AA7CA;EACI,kBAAA;EACA,eAAA;EACA,0FAAA;EACA;sBAAA;AAiDJ;;AA7CA;EACI;IACI,WAAA;EAgDN;EA7CE;IACI,mBAAA;EA+CN;EA7CE;IACI,mBAAA;IACA,mBAAA;IACA,kBAAA;EA+CN;EA7CE;IACI,mBAAA;EA+CN;EA7CE;IACI,YAAA;IACA,mBAAA;IACA,kBAAA;EA+CN;EA7CE;IACI,YAAA;EA+CN;EA7CE;IACI,mBAAA;EA+CN;EA7CE;IACI,mBAAA;EA+CN;EA7CE;IACI,kBAAA;EA+CN;EA7CE;IACI,mBAAA;EA+CN;EA7CE;IACI,YAAA;EA+CN;EA7CE;IACI,mBAAA;EA+CN;EA7CE;IACI,wBAAA;EA+CN;EA7CE;IACI,wBAAA;EA+CN;EA7CE;IACI,kBAAA;EA+CN;AACF;AA5CA,YAAA;AAEA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AA6CJ;;AA1CA;EACE,6BAAA;AA6CF;;AA1CA;EACE,8BAAA;AA6CF;;AA1CA;EACE,mBAAA;AA6CF;;AA1CA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AA6CJ;;AA1CA,eAAA;AACA;EACI,qBAAA;AA6CJ;;AA1CA;EACI,yBAAA;EACA,iCAAA,EAAA,kBAAA;EACA,8BAAA,EAAA,YAAA;EACA,4BAAA,EAAA,UAAA;EACA,6BAAA,EAAA,SAAA;AA6CJ;;AA1CA;EACI,yBAAA;AA6CJ;;AA1CA;EAAa,qBAAA;AA8Cb;;AA3CA,kBAAA;AACA;EACI,SAAA;AA8CJ;;AA3CA;EACI,SAAA;EACA,UAAA;EACA,gBAAA;AA8CJ;;AA3CA;EACI,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,+CAAA;EACA,4CAAA;EACA,2CAAA;EACA,0CAAA;EACA,uCAAA;AA8CJ;;AA3CA;EACI,mBAAA;AA8CJ;;AA3CA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AA8CJ;;AA3CA;EACI,sBAAA;EACA,YAAA;EACA,eAAA;AA8CJ;;AA3CA;EACI,gBAAA;EACA,iBAAA;AA8CJ;;AA3CA,SAAA;AACA;EACI,yBAAA;EACA,kBAAA;EACA,4BAAA;AA8CJ;;AA3CA;EACI,UAAA;AA8CJ;;AA3CA;EACI,eAAA;AA8CJ","sourcesContent":["/* SCSS Document */\n/*$main-gray-text-color: #333;*/\n/*IN MAIN STATIC*/\nbody {\n  /*main background color*/\n  /*background-color:#2b71b1;*/\n  background-color: #FFF; }\n  \n  \n/*----------Full Width Bootstrap-----------------------*/\n\n.container-fluid-full {\n  margin: 0 auto;\n  width: 100%;\n}\n\n/*----------Navigation Bars----------------------------*/\n\n.navbar {\n    margin: 0;\n    border-radius: 0;\n}\n\n/* Override navbar defaults */\n.navbar.navbar-default {\n    border: 0;\n}\n\n.navbar.navbar-default .navbar-collapse {\n    border: 0;\n}\n\n.navbar > .container {\n    width: 95%;\n    padding: 0;\n    margin-left: 2%;\n    margin-right: 0;\n}\n\n.nav-Custom-white {\n    background: white !important;\n}\n\n.nav-Custom-clear {\n    background:rgba(180,190,180,0.1)!important;\n}\n  \n.nav-Custom-blue {\n    background: #2b71b1 !important;\n}\n  \n.nav-Custom-lightBlue {\n    background: #82a8f2 !important;\n}\n  \n.nav-Custom-grey {\n    background: #5d5f63 !important;\n}\n  \n/*----------Full With Sections----------------------------*/ \n/*\n.section1_fullWidthImage {\n    background-image:url(../img/blueWindow.jpg);\n    background-position:centertop;\n    background-repeat:no-repeat;\n    background-size:cover;\n    margin:0 auto;\n    padding:20px 0px 300px 0px;\n}\n*/\n.section1_fullWidthColor {\n    background-color: #383b3f;\n    /*background-color: #1DD1C4; */\n    /*background-color: #22D4C7;*/\n    /*background: #2E5785;*/ /*DARK BLUE*/\n    /*Using a background image on top of a background colour in CSS*/\n    background-size: cover;\n    width:100%;\n    margin:0 auto;\n    min-height: 600px; }\n\n/*\n.section1_login {\n    background-color: #FFF;\n    #background-color: #E6E6E6;\n    width:100%;\n    margin:0 auto;\n    min-height: 220px; }\n*/\n\n.avatar {\n    display: block;\n    box-sizing: border-box;\n    border: 5px solid #8B8C8F;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.introBox {\n    /*on jumbatron on main page*/\n    margin-top: 150px;\n    background-color: rgba(255, 255, 255, 0);\n    color: #FFF;\n    padding: 20px; }\n\n.signUp {\n    margin-top: 150px;\n    margin-bottom: 100px;\n    background-color: #2E5785;\n    color: #5C5C5C;\n    padding-top: 0px;\n    padding-bottom: 20px; }\n\n.srsignUp {\n    margin-top: 130px;\n    margin-bottom: 100px;\n    background-color: white;\n    color: #5C5C5C;\n    padding-top: 0px;\n    padding-bottom: 20px;\n    border-radius: 20px;\n}\n\n.preLoginBox {\n    margin-top: 80px;\n    margin-bottom: 100px;\n    background-color: white;\n    color: #5C5C5C;\n    padding-top: 0px;\n    padding-bottom: 20px;\n    border-radius: 20px;\n}\n  \n.sectionJobPostingCompanySummary, .sectionJobPostingJD, .sectionEditAndCreateJob {\n    background-color: #FFF;\n    width:100%;\n    min-height: 220px;\n    margin:0 auto;\n    padding-bottom: 40px;\n    color: #404040; }\n  \n.sectionJobPostingCompanySummary {\n      padding-top: 0px;\n      border-bottom: solid 2px #D1D1D1;\n    }\n    \n.sectionEditAndCreateJob {\n      padding-top: 0px;\n    }\n\n.sectionJobPostingJD {\n      padding-top: 40px;\n    }\n\n.sectionJobPostingGrey {\n    background-color: #E6E6E6;\n    width:100%;\n    min-height: 220px;\n    margin:0 auto;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    color: #5C5C5C; }\n\n/*------------Custom Margins--------------------------*/  \n\n.noLeftMargin {\n    margin-left: 0px !important; }\n\n.noRightMargin {\n    margin-right: 0px !important; }\n\n.colPaddingLeft12 {\n    padding-left: 12px !important; }\n\n.marginLeftNeg15 {\n    margin-left: -15px; }\n\n.marginLeft15 {\n    margin-left: 15px; }\n\n.paddingTop5 {\n    padding-top: 5px; }\n\n.paddingLeft30 {\n    padding-left: 30px; }\n\n.buttomMargin15 {\n    margin-left: 15px; }\n\n.mainColumnParent {\n    margin-top: 20px;\n    padding: 0px;\n    background-color: #FFF; }\n\n.resumeformatSkillsBox:hover,\n.resumeformatLHBox:hover,\n.resumeformatRHBox:hover,\n.resumeformatReferencesBox:hover,\n.resumeformatLanguageBox:hover,\n.resumeformatMainBox:hover,\n.resumeformatEducationBox:hover {\n    cursor: pointer;\n}\n\n.menuBox {\n    background-color: #FFF; }\n\n.settingBox {\n    padding-top: 5px;\n    padding-bottom: 15px; }\n\n.resumeRepositoryElement {\n    padding-top: 5px; }\n  \n.profileContentBox {\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n\n.alignCenter {\n    text-align: center;\n}\n\n/*---ResumeFormat---*/\n.customResFormatMainColumnParentPadding {\n    padding-left: 20px; }\n\n.resumeformatBox, .resumeEditPopupBox, .resumeformatBoxSmall, .resumeformatLHBox, .resumeformatRHBox, .resumeformatMainBox, .resumeformatSkillsBox, .resumeformatLanguageBox, .resumeformatEducationBox, .resumeformatReferencesBox {\n    /*a \"virtual\" class*/\n    margin-bottom: 12px; \n    overflow: hidden;\n    // background-color: #FFF;\n}\n\n.resumeformatBoxSmall, .resumeformatLHBox, .resumeformatRHBox {\n    /*a \"virtual\" class*/\n    width: 49.1%;\n    height: 140px; }\n\n.resumeformatLHBox {\n    margin-right: 6px; }\n\n.resumeformatRHBox {\n    margin-left: 6px; }\n\n.resumeformatMainBox {\n    width: 99.6%;\n    height: 380px; }\n\n.resumeformatSkillsBox {\n    margin-left: 12px;\n    height: 684px; }\n\n/*On Same Row*/\n.resumeformatReferencesBox {\n    margin-right: 6px;\n    height: 140px;\n    }\n  \n.resumeformatEducationBox {\n    margin-left: 6px;\n    margin-right: 6px;\n    height: 140px;\n    /*set this and min-height box height as variable*/ }\n  \n.resumeformatLanguageBox {\n    margin-left: 6px;\n    height: 140px;\n    /*set this and min-height box height as variable*/ }\n/*End On Same Row*/\n\n/*End Main Box Format*/\n\n.resumeformatBoxElement {\n    padding-top: 5px; }\n  \n.resumeformatContentArea {\n    font-size: 12px;\n    margin-bottom: 20px; }\n\n/*end ResumeFormat*/\n\n.lightBlueHeader {\n    background-color: #B3B3FF;\n    color: #002855; \n    padding-top: 5px;\n    padding-bottom: 5px; }\n\n.lightGrayHeader, .settingLightGrayHeader, .thickLightGrayHeader {\n    background-color: #E7E7E7;\n    color: #7C7C7C; }\n  \n.thickLightGrayHeader {\n    padding-top: 10px;\n    padding-bottom: 10px; }\n  \n.whiteHeader {\n    background-color: #fff; \n    color: #4078c0; }\n\n.settingLightGrayHeader {\n    padding-top: 5px; }\n\n/*--------Misc Styles---------------------------*/\n\np {\n    padding: 0;\n    margin: 0;\n    display: inline;\n}\n\n.row-fluid {\n    display: flex;\n}\n\n.vertical-align {\n    display: flex;\n    align-items: center;\n}\n\n.horizontal-align {\n    display: flex;\n    justify-content: space-around;\n}\n\n.vhr{\n  border-left: 1px solid #eee;\n  height:100%;\n}\n\n.hrstyle {\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n\n.hrZeroMargin {\n    margin-top: 0px;\n    margin-bottom: 0px;\n}\n\n/*--------Boxes Style---------------------------*/ \n  \n.grayBoxBorder, .resumeformatBox, .resumeformatBoxSmall, .resumeformatLHBox, .resumeformatRHBox, .resumeformatMainBox, .resumeformatSkillsBox, .resumeformatLanguageBox, .resumeformatEducationBox, .resumeformatReferencesBox, .jobOpeningListBox {\n    border-color: #D6D0D0;\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    box-shadow: 1px 1px 1px #D6D6D6;\n    color: #4d4d4d; }\n  \n.resumeEditPopupBox {\n    border-color: #D6D0D0;\n    border-style: solid;\n    border-width: 1px;\n    color: #4d4d4d; }\n  \n.lightBoxBorder {\n    border-color: #DEDCDC;\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px; }\n    \n.lightBoxBorderNoRadius {\n    border-color: #DEDCDC;\n    border-style: solid;\n    border-width: 1px; }\n\n.grayBoxElementUnderline {\n    border-color: #D8D8D8;\n    border-bottom-style: solid;\n    border-bottom-width: 1px; }\n    \n.profileGreyBox {\n    margin-bottom: 10px; \n    background-color: #efefef; \n    height: 80px;\n}\n\n.jobOpeningListBox:hover {\n  box-shadow: 0 0 11px rgba(33,33,33,.2);\n}\n\n.mainPageButtons {\n    margin-top: 10px;\n    margin-left: -15px; }\n\n/*Left Hand Menu*/\n.menuItem > a {\n    display: inline;\n    color: #5C5C5C; }\n\n.menuItem {\n    border-color: #C4C4C4;\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n    padding-top: 15px;\n    padding-bottom: 15px; }\n\n.profileTitle {\n    font-size: 120%; }\n\n.uploadicon {\n    padding-top: 15px; }\n\n.section1_login .signUp {\n    /*this reference of names ovverides original SignUp margins because login page has different top margins*/\n    margin-top: 100px !important;\n    margin-bottom: 50px !important; }\n\n.section2 {\n    /*look at bootstrap tutorial*/\n    background-color: #FFF;\n    /*background-color: #DAE9F0;*/\n    width:100%;\n    min-height: 220px;\n    margin:0 auto;\n    padding-top: 15px;\n    padding-bottom: 40px;\n    /*color:#7E7E7E;*/\n    color: #404040; }\n    \n.section2_noMarginTop {\n    background-color: #FFF;\n    width:100%;\n    min-height: 220px;\n    margin:0 auto;\n    padding-bottom: 40px;\n    color:#404040; }\n  \n.section2_enterprise {\n    background-color: #EEE;\n    width:100%;\n    min-height: 220px;\n    margin:0 auto;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    color:#404040; } \n/*\n.section3 {\n    background-image: url(../img/startup9.jpg);\n    background-repeat: no-repeat;\n    background-size: cover;\n    min-height: 600px;\n    margin:0 auto;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    color: #7E7E7E; }\n*/\n.section4 {\n    background-color: #E6E6E6;\n    width:100%;\n    min-height: 220px;\n    margin:0 auto;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    color: #5C5C5C; }\n/*    \n.section4_fullWidthImage {\n    background-image:url(../img/officeOrange.jpg);\n    background-position:centertop;\n    background-repeat:no-repeat;\n    background-size:cover;\n    margin:0 auto;\n    min-height: 220px;\n    color: #FFF;\n    padding-top: 40px;\n    padding-bottom: 40px;\n}\n*/\n.section5 {\n    background-color: #28B8ED;\n    width:100%;\n    min-height: 220px;\n    margin:0 auto;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    color: #FFF; }\n    \n.section6 {\n    background-color: #1DD1C4;\n    /*background-color: #25d6c9;*/\n    width:100%;\n    min-height: 220px;\n    margin:0 auto;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    color: #FFF; }\n    \n.section7 {\n    background-color: #f69c3d;\n    width:100%;\n    min-height: 220px;\n    margin:0 auto;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    color: #FFF; }\n    \n.section8 {\n    background-color: #3E3F40;\n    width:100%;\n    min-height: 220px;\n    margin:0 auto;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    color: #FFF; }\n\n.sectionFooter {\n    background-color: #FFF;\n    width:100%;\n    margin:0 auto;\n    padding-top: 0px;\n    padding-bottom: 100px;\n    color: #8C8C8C; }\n\n.section2_row2 {\n    margin-top: 40px; }\n\n.table tbody tr:hover td, .table-hover tbody tr:hover th {\n  background-color: #F2F2F2; }\n  \n.col-sm-half, .col-sm-1half, .col-sm-1half-no-padding, .col-sm-2half, .col-sm-2half-no-padding, .col-sm-2ThreeQuarter,.col-sm-3half, .col-sm-5half, .col-sm-5ThreeQuarter, .col-sm-7half, .col-sm-8half {\n    position: relative;\n    min-height: 1px;\n    /*padding removed for default to not mess with LH and RH outer columns using these styles*/\n    /*padding-right: 15px;\n    padding-left: 15px;*/\n    }\n\n@media (min-width: 768px) {\n    .col-sm-half, .col-sm-1half, .col-sm-1half-no-padding, .col-sm-2half, .col-sm-2half-no-padding, .col-sm-2ThreeQuarter, .col-sm-3half, .col-sm-5half, .col-sm-5ThreeQuarter, .col-sm-7half, .col-sm-8half, .col-sm-offset-OneQuarter, .col-sm-offset-Half, .col-sm-offset-ThreeQuarter {\n        float: left;\n    }\n\n    .col-sm-half {\n        width: 4.166666667%;\n    }\n    .col-sm-1half {\n        width: 12.49999999%;\n        padding-right: 15px;\n        padding-left: 15px;\n    }\n    .col-sm-1half-no-padding {\n        width: 12.49999999%;\n    }\n    .col-sm-2half {\n        width: 21.7%;\n        padding-right: 15px;\n        padding-left: 15px;\n    }\n    .col-sm-2half-no-padding {\n        width: 21.7%;\n    }\n    .col-sm-2ThreeQuarter {\n        width: 22.91666667%;\n    }      \n    .col-sm-3half {\n        width: 29.16666667%;\n    }\n    .col-sm-5half {\n        width: 45.8333333%;\n    }\n    .col-sm-5ThreeQuarter {\n        width: 47.91666667%;\n    }\n    .col-sm-7half {\n        width: 62.5%;\n    }\n    .col-sm-8half {\n        width: 70.83333333%;\n    }\n    .col-sm-offset-OneQuarter {\n        margin-left: 2.08333333%;\n    }\n    .col-sm-offset-Half {\n        margin-left: 4.16666667%;\n    }\n    .col-sm-offset-ThreeQuarter {\n        margin-left: 6.25%;\n    }\n}\n\n/* Flexbox */\n\n.flex-container-row {\n    display: flex;\n    flex-direction: row;\n    overflow-x: auto;\n}\n\n.flex-space-around {\n  justify-content: space-around;\n}\n\n.flex-space-between {\n  justify-content: space-between;\n}\n\n.flex-align-center {\n  align-items: center;\n}\n\n.modal-space-between-confirm-buttons {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n/* Whitespace */\n.keep-whitespace {\n    white-space: pre-line;\n}\n\n.rotate-fortyfive {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg); /* Safari/Chrome */\n    -moz-transform: rotate(-45deg);    /* Firefox */\n    -o-transform: rotate(-45deg);      /* Opera */\n    -ms-transform: rotate(-45deg);     /* IE 9 */\n}\n\n.hoverable:hover{\n    background-color: #e6ecf5;\n}\n\n.modal-90w { width: 90% !important; }\n\n\n/* Sidebar stuff */\n.sidebar {\n    margin: 0;\n}\n\n.sidebar ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.sidebar ul li {\n    margin: 0;\n    padding: 15px 20px;\n    font-size: 16px;\n    font-weight: 100;\n    color: white;\n    display: block;\n    -webkit-transition: background 0.3s ease-in-out;\n    -moz-transition: background 0.3s ease-in-out;\n    -ms-transition: background 0.3s ease-in-out;\n    -o-transition: background 0.3s ease-in-out;\n    transition: background 0.3s ease-in-out;\n}\n\n.sidebar ul li:hover {\n    background: #7c889c;\n}\n\n.imgStyle {\n    width: 100%;\n    height: auto;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.imgStyle:hover {\n    background-color: #000;\n    opacity: 0.5;\n    cursor: pointer;\n}\n\n.companyImgStyle {\n    max-width: 200px;\n    max-height: 200px;\n}\n\n/* Card */\n.cardStyle {\n    border: 1px solid #b9bcc7;\n    border-radius: 8px;\n    padding: 10px 10px 10px 10px;\n}\n\n.logoStyle {\n    width: 10%;\n}\n\n.logoStyle:hover {\n    cursor: pointer;\n}\n\n/*# sourceMappingURL=sass.css.map */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
